import React from 'react';

import { Container, QuantityValue, QuantityText } from './styles';

function FileCounter({fileSelectedQuantity}) {
  return (
    <Container>
      <QuantityValue>
        {fileSelectedQuantity}
      </QuantityValue>
      <QuantityText>
      {
      ` ${fileSelectedQuantity > 1
        ? 'arquivos selecionados'
        : 'arquivo selecionado'}`
      }
      </QuantityText>
    </Container>
  );
}

export default FileCounter;
